import React, { Component } from 'react'
import { connect } from 'react-redux'
import { faGreaterThan } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { CLEAR_HELP_TEXT } from '../actions/actionTypes'



class HelpPanel extends Component {

    handleClick = () => {
        this.props.clearHelp()
    }
    render() {
        const { helpText } = this.props
        const bodyParts = (helpText?.body || '').split("\n")

        if (! helpText?.id) {
            return null
        }

        return (
            <div className='help-panel-container'>
                <div className='help-panel-title'>
                    <div>{helpText.title}</div>
                    <FontAwesomeIcon 
                        className='clickable'
                        onClick={this.handleClick}
                        icon={faGreaterThan} 
                        size="sm" />
                </div>
                <div className='help-panel-body'>
                    {
                        bodyParts.map((t, inx) => (
                            <div key={`bp-${inx}`}>{t}&nbsp;</div>
                        ))
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { helpText } = state
    return {
        helpText
    }
}

const mapDispatchToProps = dispatch => {
    return {
        clearHelp: () => dispatch({ type: CLEAR_HELP_TEXT })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpPanel)
